import React from 'react';

import SwymoLogoDark from '../../assets/image/swymo-logo.png';
import SwymoLogoWhite from '../../assets/image/swymo-logo-white.png';

export type SwymoLogoProps = {
  /** logo color: dark for light backgrounds, white for dark backgrounds */
  variant?: 'dark' | 'white';
  className?: string;
};

const logoByVariant = {
  dark: SwymoLogoDark,
  white: SwymoLogoWhite,
};

const SwymoLogo = ({ variant = 'dark', className }: SwymoLogoProps) => {
  return <img src={logoByVariant[variant]} className={className} alt="Swymo Logo" />;
};

export { SwymoLogo };
